module.exports = __webpack_public_path__ + "static/img/16.60c7d71.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/16.png
// module id = R9dc
// module chunks = 1